export const GLOBAL_MODALS = {
  BM_CROSS_SALE: 'bmCrosSale',
  PM_CROSS_SALE: 'pmCrosSale',
  HELP_CENTER: 'helpCenter',
  ADD_DOMAIN: 'addDomain',
  CQ_PARAMS: 'cqParamsModal',
  THREAT_GROUP_TOOLTIP: 'threatGroupTooltipModal',
  PLATFORM_CONNECTION: 'platformConnection',
  GET_TAG: 'getTag',
  BM_SETUP: 'bzSetup',
  EXTEND_TRIAL: 'extendTrial',
  TRIAL_ENDED: 'trialEnded',
  TRIAL_PRE_END: 'trialPreEnd',
  DOMAIN_REACTIVATION: 'domainReactivation',
  GOOGLE_DISCONNECTED: 'googleDisconnected',
  EDIT_DOMAIN_PRODUCTS: 'editDomainProducts',
} as const

export type GlobalModals = (typeof GLOBAL_MODALS)[keyof typeof GLOBAL_MODALS]
